import {Typography} from '@material-ui/core';
import React from 'react';
import './FieldValue.scss';

// create a react functional component to render the field value with field label
const FieldValue = ({
  label,
  value,
  onClickAction,
  className = ''
}: {
  label: string;
  value: string | React.ReactNode;
  onClickAction?: string | React.ReactNode;
  className?: string;
}): React.ReactElement => {
  const handleClickAction = (): void => {
    if (typeof onClickAction === 'function') {
      onClickAction();
    }
  };
  return (
    <div className={`field-value-wrapper ${className}`}>
      <Typography className="field-label">{label}</Typography>
      <Typography
        className="field-value-text"
        onClick={() => handleClickAction()}>
        {value}
      </Typography>
    </div>
  );
};

export default FieldValue;
